import { EditUserProfileForm } from "../../components/UserProfile/EditUserProfileForm";

export function EditUserProfile() {
  return <EditUserProfileForm />;
}
